<script>
  import { mergeData } from 'vue-functional-data-merge'
  import { getScopedStyleData } from '~/utils/dom'

  export default {
    name: 'CardSection',
    functional: true,
    render (h, { children, parent, props, data }) {
      const componentData = {
        class: {
          'card-section': true,
          dark: props.dark,
          light: props.light,
          padded: props.padding,
        },
      }
      const styleData = getScopedStyleData(parent)

      return h('div', mergeData(data, styleData, componentData), [children])
    },
    props: {
      dark: { type: Boolean, default: false },
      light: { type: Boolean, default: false },
      padding: { type: Boolean, default: true },
    },
  }
</script>

<style lang="scss" scoped>
  @import "~assets/scss/frontend/_colours";
  @import "~foundation-sites/scss/util/_unit";
  @import "~foundation-sites/scss/util/_breakpoint";

  .card-section {
    padding: 0;

    &.padded {
      padding: 1rem;

      & + .padded {
        padding-top: 0;
      }
    }

    &.dark {
      background-color: #f8f6ef;
    }
    &.light {
      background-color: $colour-magnolia-light;
    }
  }
</style>
